export default {
      id: "linkedin-negative-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#linkedin-negative",
      toString: function () {
        return this.url;
      }
    }